// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z1DC","toggleWrap":"styles_toggleWrap__uRpFR","content":"styles_content__31lKV","selectAreaCode":"styles_selectAreaCode__16Bbu"};